import { KeyRoots } from './KeyRoots.enums';

// This function generates a unique key for React components
// use it only when you have no better alternative like id or some unique identifier

function generateUniqueReactKey() {
  let counter = 0;
  const keys = {} as Record<
    KeyRoots,
    { [index: number]: `${KeyRoots}_${string}` }
  >;

  return function generateKey(mapKey: KeyRoots, index: number) {
    if (keys[mapKey] && keys[mapKey][index]) {
      return keys[mapKey][index];
    }

    counter++;
    keys[mapKey] = { ...keys[mapKey], [index]: `${mapKey}_${counter}` };

    return keys[mapKey][index];
  };
}

const generateReactKey = generateUniqueReactKey();

export { generateReactKey, KeyRoots };
